export function svgStyles(svgIdPrefix: string) {
  return <></>;
}
